import * as React from "react";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { IFormData, IInputType } from "./formFields";
import { Input } from "./Input";

export interface IFormProps {
    fieldNames: IInputType[];
    onChange?: (data: IFormData) => void;
    validateForm: number;
    onFormValidated: (isValid: boolean) => void;
    resetForm: number;
    defaultValues?: IFormData;
}

export const Form = ({
    fieldNames,
    onChange,
    validateForm,
    onFormValidated,
    resetForm,
    defaultValues
}: IFormProps): JSX.Element => {
    const [formData, setFormData] = useState({});
    const [validate, setValidate] = useState<number>(0);
    const [reset, setReset] = useState<number>(0);
    const formValidations = useRef({});

    const onChanged = (e: ChangeEvent<HTMLInputElement>) => {
        const data = { ...formData };
        data[e.target.name] = e.target.value;
        setFormData(data);
        onChange(data);
    };

    const onFieldValidated = (name: string, isValid: boolean, i: number) => {
        if (!formValidations || !formValidations.current) {
            return;
        }
        const validations = { ...formValidations.current };
        validations[name] = isValid;
        formValidations.current = validations;
        i + 1 === fieldNames.length && onFormValidated(!Object.values(formValidations.current).includes(false));
    };

    useEffect(() => {
        setValidate(validateForm);
    }, [validateForm]);

    useEffect(() => {
        setReset(resetForm);
    }, [resetForm]);

    useEffect(() => {
        if (defaultValues) {
            setFormData(defaultValues);
            onChange(defaultValues);
        }
    }, [defaultValues]);

    return (
        <form className="form-section">
            {fieldNames.map((field, i) => (
                <Input
                    config={field}
                    onChange={onChanged}
                    validate={validate}
                    onValidate={(isValid) => onFieldValidated(field.name, isValid, i)}
                    reset={reset}
                    defaultValue={(defaultValues && defaultValues[field.name]) || ""}
                    key={field.label + i}
                ></Input>
            ))}
        </form>
    );
};
